export default __webpack_public_path__ + "static/media/logo-color.f09101bb.png";